import { JsonField } from '../../types/jsonField';

export const transitionParametersTemplate: JsonField[] = [
  {
    key: 'priority',
    type: 'number',
    label: 'Priority',
    description: 'The priority of this transition (higher numbers = higher priority)',
    defaultValue: 0,
  },
  {
    key: 'conditions',
    type: 'array',
    label: 'Conditions',
    description: 'List of conditions that must be met for this transition',
    defaultValue: [],
  },
  {
    key: 'timeout',
    type: 'number',
    label: 'Timeout',
    description: 'Maximum time allowed for this transition (in seconds)',
    defaultValue: 0,
  },
];

export const validationRulesTemplate: JsonField[] = [
  {
    key: 'required_states',
    type: 'array',
    label: 'Required States',
    description: 'States that must be active for this transition to be valid',
    defaultValue: [],
  },
  {
    key: 'forbidden_states',
    type: 'array',
    label: 'Forbidden States',
    description: 'States that must not be active for this transition to be valid',
    defaultValue: [],
  },
  {
    key: 'custom_rules',
    type: 'object',
    label: 'Custom Rules',
    description: 'Custom validation rules for this transition',
    children: [
      {
        key: 'rule_type',
        type: 'string',
        label: 'Rule Type',
        description: 'Type of validation rule',
        options: [
          { label: 'Time Based', value: 'time_based' },
          { label: 'Resource Based', value: 'resource_based' },
          { label: 'State Based', value: 'state_based' },
        ],
      },
      {
        key: 'parameters',
        type: 'object',
        label: 'Rule Parameters',
        description: 'Parameters for the validation rule',
        children: [
          {
            key: 'threshold',
            type: 'number',
            label: 'Threshold',
            description: 'Threshold value for the rule',
          },
          {
            key: 'comparison',
            type: 'string',
            label: 'Comparison',
            description: 'Comparison operator',
            options: [
              { label: 'Greater Than', value: 'gt' },
              { label: 'Less Than', value: 'lt' },
              { label: 'Equals', value: 'eq' },
            ],
          },
        ],
      },
    ],
  },
];

export const improvementParametersTemplate: JsonField[] = [
  {
    key: 'target_metrics',
    type: 'object',
    label: 'Target Metrics',
    description: 'Target metrics for improvement',
    children: [
      {
        key: 'cycle_time',
        type: 'number',
        label: 'Cycle Time',
        description: 'Target cycle time in seconds',
      },
      {
        key: 'throughput',
        type: 'number',
        label: 'Throughput',
        description: 'Target throughput per hour',
      },
      {
        key: 'quality',
        type: 'number',
        label: 'Quality',
        description: 'Target quality percentage',
      },
    ],
  },
  {
    key: 'improvement_strategies',
    type: 'array',
    label: 'Improvement Strategies',
    description: 'List of strategies to achieve the target metrics',
    defaultValue: [],
  },
];
